// LOP - Badges de descuento basados en metafields de colección
document.addEventListener('DOMContentLoaded', function() {
  // Función para aplicar descuentos visuales a los precios
  function applyCollectionDiscounts() {
    const productCards = document.querySelectorAll('.product-card, .product-cart-item');
    
    productCards.forEach(card => {
      const discountBadges = card.querySelectorAll('.LOP-discount-badge--number');
      
      discountBadges.forEach(badge => {
        const discountText = badge.querySelector('.LOP-discount-text').textContent;
        const discountPercentage = parseInt(discountText.match(/(\d+)%/)[1]);
        
        // Buscar el precio en la tarjeta
        const priceElement = card.querySelector('.product-price');
        if (priceElement) {
          const originalPrice = priceElement.querySelector('.product-price--regular');
          const salePrice = priceElement.querySelector('.product-price--sale');
          
          if (originalPrice && salePrice) {
            // El precio ya está formateado correctamente
            return;
          }
          
          // Si no hay precio con descuento, crear uno
          if (originalPrice && !salePrice) {
            const originalPriceText = originalPrice.textContent;
            const originalPriceValue = parseFloat(originalPriceText.replace(/[^0-9.]/g, ''));
            const discountedPrice = originalPriceValue * (100 - discountPercentage) / 100;
            
            // Crear elemento de precio con descuento
            const salePriceElement = document.createElement('span');
            salePriceElement.className = 'product-price--sale';
            salePriceElement.textContent = formatMoney(discountedPrice);
            
            // Agregar después del precio original
            originalPrice.parentNode.insertBefore(salePriceElement, originalPrice.nextSibling);
          }
        }
      });
    });
  }
  
  // Función para formatear dinero (simplificada)
  function formatMoney(amount) {
    return '$' + amount.toFixed(2);
  }
  
  // Ejecutar cuando el DOM esté listo
  applyCollectionDiscounts();
  
  // Ejecutar cuando se carguen nuevos productos (para AJAX)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        applyCollectionDiscounts();
      }
    });
  });
  
  // Observar cambios en el contenedor de productos
  const productGrid = document.querySelector('#product-grid');
  if (productGrid) {
    observer.observe(productGrid, {
      childList: true,
      subtree: true
    });
  }
}); 